<div class="row row-sm">
    <div class="col-lg-12">

        <div class="card-body">

            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                   Sub Caste

                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Add New Sub Caste Record

                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                Sub Caste
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Update New Sub Caste Record
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                Sub Caste </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Delete New Sub Caste Record
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">
                <div class="row row-sm add-form ">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="CasteForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Caste Code
                                                </mat-label>
                                                <mat-select #select2333 placeholder="Caste Code" formControlName="CategoryId">
                                                    <mat-select-filter *ngIf="select2333.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                        [array]="CasteList"
                                                        (filteredReturn)="filteredCasteList =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredCasteList"
                                                        [value]="item.CdCode">
                                                        {{item.CdCode}} - {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                *ngIf="CasteForm.controls['CategoryId'].touched && CasteForm.controls['CategoryId'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                 Caste Name
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="50" placeholder="Caste Name"
                                                    formControlName="CasteName" matInput >
                                                    <mat-error class="margin_tp"
                                                    *ngIf="CasteForm.controls['CasteName'].touched && CasteForm.controls['CasteName'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                    *ngIf="CasteForm.controls['CasteName'].touched && CasteForm.controls['CasteName'].errors?.pattern">
                                                    Invalid
                                                </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 prpl">
                                    <div class="col-sm-12">
                                        <!-- (click)="submit()" -->
                                        <button id="Save" type="button" *ngIf="submitButton"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="submit()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 5px;">
                                                Save
                                            </span>
                                        </button>
                                        <!-- (click)="update()" -->
                                        <button id="Update" type="button" *ngIf="editButton"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 5px;">
                                                Update
                                            </span>
                                        </button>
                                        <!-- (click)="openConformationModalBox()" -->
                                        <button id="Delete" type="button" *ngIf="deleteButton"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1"
                                            (click)="openConformationModalBox()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/trash.gif"
                                                    style="margin-right: 5px;">
                                                Delete
                                            </span>
                                        </button>
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="20vh"  src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                Back
                                            </span>
                                        </button>

                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>